// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"add5af35","426":"a174262c","438":"d9a779e4","453":"68d2f560","507":"693a7840","583":"04aad4ff","801":"73aa4c33","870":"48360774"}[chunkId] + ".chunk.js";
};